<!--
 * @Author: DY
 * @Date: 2024-12-05 16:55:29
 * @LastEditTime: 2026-03-20 16:10:06
 * @Description: 柴油领用申请表单
 * @FilePath: \ShiMo_Mobile\src\views\storage\dieselFuelRequisitionApply\form.vue
-->
<template>
    <v-touch @swiperight="closeAllocationForm" class="wrapper">
        <div class="dieselFuelRequisitionApplyForm commonFormStyles">
            <HeaderNav header-title="柴油领用申请表" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: closeAllocationForm }"></HeaderNav>
            <section>
                <van-tabs class="currencyTabsStyle" v-model="activeTab" animated :scrollspy="false">
                    <van-tab title="申请信息表">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>申请信息表</h5>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="柴油出库单号"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.OutstockNumber"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="车牌号"
                                        placeholder="选择车牌号"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_18@2x.png')"
                                        v-model="formData.CarLicense"
                                        @click="selectCar"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="车辆类型"
                                        placeholder="选择车牌号"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="carTypeStr"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="车辆管理部门"
                                        placeholder="选择车牌号"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                        v-model="formData.ManageDeptName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="成本中心"
                                        placeholder="选择车牌号"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_21@2x.png')"
                                        v-model="formData.CostCenter"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="领用部门负责人"
                                        placeholder="选择车牌号"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.ManageDeptUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="仓库名称"
                                        placeholder="选择仓库"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                                        v-model="formData.StockName"
                                        @click="selectStock"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="库管员"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.StoremanName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.Creator"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.CreationTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.OutstockUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.OutstockTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="状态"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="Status"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        label="备注"
                                        type="textarea"
                                        :rows="2"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                        v-model="formData.Remarks"
                                    ></van-field>
                                </li>
                                <li class="photoUpload">
                                    <van-cell title="照片上传" :icon="require('@/assets/images/icons/icon_24@2x.png')"></van-cell>
                                    <div class="file-list">
                                        <van-uploader
                                            multiple
                                            preview-image
                                            preview-full-image
                                            v-model="fileList"
                                            upload-icon="plus"
                                            :before-read="beforeRead"
                                            :before-delete="beforeDelete"
                                            :show-upload="!isDisabled"
                                            :deletable="!isDisabled"
                                            :readonly="canUseNitive"
                                            :capture="capture"
                                            @click-upload="clickUpload"
                                        ></van-uploader>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="申请明细表">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>申请明细表</h5>
                                    <van-icon name="add" v-if="!isDisabled" @click="selectMaterial"></van-icon>
                                </li>
                                <dl class="materialList" v-for="(item, index) in formData.Materials" :key="`material_${index}`">
                                    <dt>
                                        <van-icon name="clear" v-if="!isDisabled" @click="deleteMaterial(index)"></van-icon>
                                        <h5>物料代码</h5>
                                        <p>{{ item.MaterialCode }}</p>
                                    </dt>
                                    <dd>
                                        <div>
                                            <p>短描述：</p>
                                            <input type="text" disabled v-model="item.MaterialShortName">
                                        </div>
                                        <div>
                                            <p>长描述：</p>
                                            <input type="text" disabled v-model="item.MaterialName">
                                        </div>
                                        <div>
                                            <p>单位：</p>
                                            <input type="text" disabled v-model="item.Unit">
                                        </div>
                                        <div>
                                            <p>柴油出库量(L)：</p>
                                            <input type="text" disabled v-model="item.VolumeOutstockL">
                                        </div>
                                        <div>
                                            <p>折算系数：</p>
                                            <input type="text" disabled v-model="item.VolumeCoefficient">
                                        </div>
                                        <div>
                                            <p>柴油出库量(千克)：</p>
                                            <input type="text" disabled v-model="item.VolumeOutstock">
                                        </div>
                                        <div>
                                            <p>存放位置：</p>
                                            <input type="text" disabled v-model="item.GridName">
                                        </div>
                                        <div>
                                            <p>出库前库存：</p>
                                            <input type="text" disabled v-model="item.VolumeCurrent">
                                        </div>
                                        <div>
                                            <p>出库后库存：</p>
                                            <input type="text" disabled v-model="item.VolumeAfter">
                                        </div>
                                    </dd>
                                </dl>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
            </section>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" v-if="formData.Id != '' && formData.Status == 0" @click="submitForm">
                        提交
                    </button>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import currencyFun from '@/assets/js/currencyFun/index.js';
import JYExternalNative from '@/assets/js/JYExternalNative.js';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    name: 'diesel-fuel-requisition-apply-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/dieselFuelRequisitionApply') {
            this.$store.commit('noKeepAlive', 'diesel-fuel-requisition-apply-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isDisabled: false,
            activeTab: 0,
            formData: {
                Id: '',
                OutstockNumber: '',
                OutstockUserId: '',
                OutstockUserName: '',
                OutstockTime: '',
                Status: 0,
                Remarks: '',
                AutoIndex: 0,
                YearIndex: '',
                CarLicense: '',
                ManageDeptId: '',
                ManageDeptName: '',
                CarType: '',
                CostCenter: '',
                ManageDeptUserId: '',
                ManageDeptUserName: '',
                PictureId: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                StoremanId: '',
                StoremanName: '',
                StoremanPhone: '',
                Creator: '',
                CreationTime: '',
                Materials: [],
            },
            Status: '',
            fileList: [],
            canUseNitive: false,
            capture: ['camera'],
            isSaveOperation: false,
            tenantId: '',
            carTypeStr: '',
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.car) {
            this.formData.CarLicense = this.$route.params.car[0].car_license;
            this.formData.ManageDeptId = this.$route.params.car[0].manage_dept_id;
            this.formData.ManageDeptName = this.$route.params.car[0].manage_dept_name;
            this.formData.CarType = this.$route.params.car[0].car_type;
            this.carTypeStr = this.loadCarType(this.formData.CarType);
            this.formData.CostCenter = this.$route.params.car[0].cost_center;
            this.formData.ManageDeptUserId = this.$route.params.car[0].manage_dept_user_id;
            this.formData.ManageDeptUserName = this.$route.params.car[0].manage_dept_user_name;
        }
        if (this.$route.params.stock) {
            this.formData.StockId = this.$route.params.stock[0].id;
            this.formData.StockCode = this.$route.params.stock[0].stock_code;
            this.formData.StockName = this.$route.params.stock[0].stock_name;
            this.formData.StoremanId = this.$route.params.stock[0].storeman_id;
            this.formData.StoremanName = this.$route.params.stock[0].storeman_name;
            this.formData.StoremanPhone = this.$route.params.stock[0].storeman_phone;
        }
        if (this.$route.params.material) {
            const Id = this.formData.Materials[0]?.Id || '';
            this.formData.Materials = [{
                Id: Id,
                MaterialCode: this.$route.params.material[0].material_code,
                MaterialName: this.$route.params.material[0].material_name,
                MaterialShortName: this.$route.params.material[0].material_short_name,
                Unit: this.$route.params.material[0].unit,
                VolumeCoefficient: this.$route.params.material[0].volume_coefficient,
            }];
        }
    },
    created() {
        this.initpage();
    },
    mounted() {
        this.tenantId = this.$takeTokenParameters('TenantId');
        this.canUseNitive = JYExternalNative.$canUse('chooseFileHttpUpload');
    },
    destroyed() {},
    methods: {
        async initpage() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const type = this.$route.params.type;
            if (type === 'add') {
                this.formData.Creator = this.$takeTokenParameters('Name');
                this.formData.CreationTime = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
            }
            if (type === 'see') {
                this.isDisabled = true;
            }
            if (type === 'edit' || type === 'see') {
                this.formData = await this.getFormData(this.$route.params.data.id);
                this.carTypeStr = this.loadCarType(this.formData.CarType);
                if ((this.formData.PictureId || '') !== '') {
                    const fileData = this.formData.PictureId.split(',');
                    this.loadFile(fileData);
                }
            }
            this.Status = this.loadStatus(this.formData.Status);
            this.$toast.clear();
        },

        loadCarType(type) {
            const carType = ['叉车', '铲车', '洒水车', '皮卡', '板车'];
            if (type < 4) {
                return carType[type];
            }
            return carType[4];
        },

        loadStatus(nub) {
            const staus = ['待提交', '待审核', '未通过', '待出库', '已出库', '已作废'];
            return staus[nub];
        },
        loadFile(fileData) {
            const addfileList = [];
            fileData.filter(item => {
                const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${item}/download`;
                addfileList.push({ fileId: item, url: url, isImage: true });
            });
            this.fileList = addfileList;
        },
        // 选择车辆
        selectCar() {
            if (this.isDisabled) {return;}
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择车辆',
                    sourcePath: 'dieselFuelRequisitionApplyForm',
                    listCode: 'outstock_oil_select_plate',
                    callbackDataKey: 'car',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    pageIndex: 0,
                    initIndex: 0,
                    headerList: [{
                        name: '车牌号',
                        code: 'car_license',
                        isTitle: true,
                    }, {
                        name: '部门',
                        code: 'manage_dept_name',
                        icon: 'icon_29@2x',
                    }, {
                        name: '类型',
                        code: 'car_type_str',
                        icon: 'icon_13@2x',
                    }, {
                        name: '成本中心',
                        code: 'cost_center',
                        icon: 'icon_21@2x',
                    }, {
                        name: '油箱容量',
                        code: 'capacity',
                        icon: 'icon_38@2x',
                    }, {
                        name: '部门负责人',
                        code: 'manage_dept_user_name',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },

        // 选择仓库
        selectStock() {
            if (this.isDisabled) {return;}
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库',
                    sourcePath: 'dieselFuelRequisitionApplyForm',
                    listCode: 'outstock_oil_select_stock',
                    callbackDataKey: 'stock',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    pageIndex: 0,
                    initIndex: 0,
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '库管员',
                        code: 'storeman_name',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },
        // 上传照片
        async clickUpload() {
            const opt = {
                maxNum: 10, // 最大上传个数
                fileType: 1, // 文件类型：0全部，1图片，2，视频
                albumSelection: true, //  true从相册选择，false直接拍照or录像
                showCameraBtn: true, // 相册选择是否展示 拍照按钮
                addWatermarkType: 0, // 加水印，0或null不加，1仅拍照、录像加，2拍照、录像、相册选择的都加
                httpConfig: {
                    host: this.GLOBAL.FILE_BASE_URL,
                    api: 'file-manage/many',
                    param: {
                        FileType: 0,
                        BusinessTypeCode: 'ProductionAffix',
                        DataId: this.formData.Id,
                        DirectoryId: '',
                    },
                },
            };
            const res = await JYExternalNative.$chooseFileHttpUpload(opt);
            const { DataContext } = JSON.parse(res);
            const files = DataContext.map(item => {
                const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${item.Id}/download`;
                return { url: url, isImage: true, fileId: item.Id };
            });
            this.fileList.push(...files);
            this.formData.PictureId = this.fileList.map(item => item.fileId).toString();
            await this.saveFormData(this.formData);
        },
        beforeRead() {
            if ((this.formData.Id || '') === '') {
                this.$toast('请先保存表单数据！');
                return false;
            }
            return true;
        },
        async beforeDelete(file) {
            const res = await this.deleteRequest(`${this.GLOBAL.FILE_BASE_URL}file-manage/${file.fileId}`);
            if (res) {
                const index = this.fileList.findIndex(item => item.fileId === file.fileId);
                if (index >= 0 ) {
                    this.fileList.splice(index, 1);
                }
                this.$toast.success('删除成功。');
                this.formData.PictureId = this.fileList.map(item => item.fileId).toString();
                await this.saveFormData(this.formData);
            }
        },
        selectMaterial() {
            const materialCodes = this.formData.Materials.map(item => item.MaterialCode).join(',');
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择物料',
                    sourcePath: 'dieselFuelRequisitionApplyForm',
                    requestUrl: `/basicplatform/tabledata?&material_codes=${materialCodes}`,
                    listCode: 'outstock_oil_select_material',
                    callbackDataKey: 'material',
                    relationKey: 'material_code',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '物料代码',
                        code: 'material_code',
                        isTitle: true,
                    }, {
                        name: '长描述',
                        code: 'material_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '单位',
                        code: 'unit',
                        icon: 'icon_24@2x',
                    }, {
                        name: '最近折算系数',
                        code: 'volume_coefficient',
                        icon: 'icon_38@2x',
                    }],
                },
            });
        },
        deleteMaterial(index) {
            this.formData.Materials.splice(index, 1);
        },
        async saveForm() {
            if ((this.formData.Materials || []).length === 0) {
                this.$toast('请添加物料！');
                return;
            }
            const res = await this.saveFormData(this.formData);
            if (res) {
                this.formData = res;
                this.isSaveOperation = true;
                this.$toast.success('保存成功。');
            }
        },

        submitForm() {
            this.$dialog.confirm({
                message: `确认提交出库单 \n【${this.formData.OutstockNumber}】吗？`,
            }).then(async () => {
                const res = await this.submitRequest(this.formData.Id);
                if (res) {
                    this.$toast.success('提交成功。');
                    this.isSaveOperation = true;
                    this.closeAllocationForm();
                }
            });
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'dieselFuelRequisitionApply',
                params: {
                    saveCallback: this.isSaveOperation,
                },
            });
        },
        getFormData(id) {
            return this.$axios.$get(`/interfaceApi/procurement/outstock_oil/${id}`);
        },
        uploadRequest(url, requestData) {
            return this.$axios.$post(url, requestData);
        },
        deleteRequest(url) {
            return this.$axios.$delete(url, {});
        },
        saveFormData(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/outstock_oil/change', requestData);
        },
        submitRequest(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock_oil/submit?id=${id}`, {});
        },
    },
};
</script>
<style lang="stylus">
.dieselFuelRequisitionApplyForm
    background #F0F0F0
    section
        height 0
        flex 1
    .formList
        padding 10rpx
        .formItem
            background #fff
            .photoUpload
                .van-cell
                    border none
                .file-list
                    padding 0 14rpx 10rpx
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                h5
                    font-size 16rpx
                    color #e93743
                p
                    margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    &:last-child
                        width 100%
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.7)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.7)
</style>